<mp-platformcatalog-panel
  expanded
  disabled
  editMode
  [nameControl]="nameControl()"
  [(activeTab)]="activeTab"
  [countInfo]="countInfo"
  (editModeChange)="onEditModeChange($event)"
  (save)="emitSave($event)"
>
  <!-- Buttons -->
  <mp-actions-slide-toggle-button
    platformcatalog-panel-action-button
    icon="published_with_changes"
    label="Datenquellenübergreifend indexieren"
    [checked]="isSearchMultipleDataSourcesActive"
    (buttonClick)="toggleIsSearchMultipleDataSourcesActive()"
  />

  <!-- Content -->
  @if (activeTab === 'catalogs') {
    <mp-industry-catalogs-container
      [catalogs]="kataloge"
      [searchTerm]="searchTerm"
      (searched)="handleSearched($event)"
      (addItemsClicked)="letUserAddCatalogs($event)"
      (itemRemoved)="handleItemRemoved($event)"
      (itemsAdded)="handleItemsAdded($event)"
      (itemSorted)="handleItemSorted($event)"
      (industryCatalogClicked)="navigateToIndustryCatalogDetail($event)"
    />
  }

  @if (activeTab === 'organizations') {
    <mp-organization-selector
      headerTitle="Organisationen zuordnen"
      headerIcon="account_balance"
      [selectorItems]="organizations"
      (addItemsClicked)="letUserAddOrganizations()"
      (deleteToggleClicked)="removeToggleOrganization($event)"
    />
  }
</mp-platformcatalog-panel>
